export { default } from './OplatiQr';
